import type { CatalogImageMaskKind } from "@/features/catalog/utils/catalogReveal";
import { shouldShowCatalogReplyCount } from "@/features/catalog/utils/catalogReveal";

interface CatalogReplyCountProps {
  maskKind: CatalogImageMaskKind;
  showCount: boolean;
  showUnreadCount: boolean;
  totalCount: number;
  unreadCount: number | undefined;
}

export const CatalogReplyCount: React.FunctionComponent<CatalogReplyCountProps> =
  function CatalogReplyCount({
    maskKind,
    showCount,
    showUnreadCount,
    totalCount,
    unreadCount,
  }: CatalogReplyCountProps) {
    if (
      !shouldShowCatalogReplyCount({
        maskKind,
        showCount,
        showUnreadCount,
        unreadCount,
      })
    ) {
      return null;
    }

    return (
      <data
        value={totalCount}
        className="absolute bottom-1 right-1 z-10 px-1.5 py-0.5 text-xs font-bold bg-black/70 text-white rounded pointer-events-none"
      >
        {showCount && totalCount}
        {showUnreadCount && unreadCount !== undefined && unreadCount > 0 && (
          <strong className="catalog-unread-count text-2xs ml-0.5">
            +{unreadCount}
          </strong>
        )}
      </data>
    );
  };
